<script lang="ts" setup>
import { ElButton } from "element-plus";
import { ref, watchEffect } from "vue";
import { excludeObjectKeys } from "../../../utils";
import IForm from "../../form/src/form.vue";
import { excludeSearchPropsKeys, SearchEmits, SearchProps } from "./search";

defineOptions({
  name: "ISearch",
});
const props = defineProps(SearchProps);
const emit = defineEmits(SearchEmits);

const bindAttrs = ref<any>();
watchEffect(() => {
  const attrs = excludeObjectKeys(props, excludeSearchPropsKeys);
  if (!attrs.fileds) {
    attrs.fileds = [];
  }
  if (!attrs.fields.some((item: any) => item.prop === "searchBtn")) {
    attrs.fields.push({
      prop: "searchBtn",
      comp: "slot",
    });
  }
  bindAttrs.value = attrs;
});

const formRef = ref();
defineExpose({
  getRef() {
    return formRef.value?.getRef();
  },
});

const handleChange = (key: string, value: any, ref: any, comp: string) => {
  emit("change", key, value, ref, comp);

  if (props.showDefaultBtn) {
    // if (comp === "el-input") {
    //   // el-input change 调用查询事件
    //   // 即在输入框值变化和按下回车时，触发查询事件。
    //   emit("search", props.model);
    // }
  } else {
    emit("search", props.model);
  }
};
</script>

<template>
  <div class="i-search">
    <IForm ref="formRef" v-bind="bindAttrs" @change="handleChange">
      <template v-for="(item, key) in $slots" :key="key" #[key]>
        <slot
          v-if="key !== 'searchBtn' && key !== 'btn'"
          :name="key"
          v-bind="item"
        />
      </template>
      <template #searchBtn>
        <div class="i-search__opera">
          <template v-if="showDefaultBtn">
            <ElButton
              type="primary"
              :loading="loading"
              @click="emit('search', model)"
            >
              {{ searchBtnText }}
            </ElButton>
            <ElButton :loading="loading" @click="emit('reset')">{{
              resetBtnText
            }}</ElButton>
          </template>
          <template v-if="$slots.btn">
            <slot name="btn" />
          </template>
        </div>
      </template>
    </IForm>
  </div>
</template>
